import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFireDatabase } from '@angular/fire/database';
import { ToastrService } from 'ngx-toastr';
import { Observable, of } from 'rxjs';
import { NotificationType } from '../../shared/notification-type';
import { FirebaseMessage } from '../../shared/firebase-message.model';
import { catchError, filter, flatMap, take, tap } from 'rxjs/operators';
import { AngularFireMessaging } from '@angular/fire/messaging';

@Injectable()
export class MessagingService {

  constructor(
    private db: AngularFireDatabase,
    private afAuth: AngularFireAuth,
    private afMessaging: AngularFireMessaging,
    private toastr: ToastrService
  ) {
  }


  getPermission() {
    this.afMessaging.requestPermission
      .pipe(
        take(1),
        flatMap(() => {
          console.log('Notification permission granted.');
          return this.afMessaging.getToken;
        }),
        tap(token => console.log(token)),
        catchError((err) => {
          console.log('Unable to get permission to notify.', err);
          return of(err);
        })
      )
      .subscribe();
  }

  onMessage(type: NotificationType): Observable<FirebaseMessage> {
    return this.afMessaging.messages
      .pipe(
        tap((payload: FirebaseMessage) => console.log('Message received. ', payload)),
        filter((payload: FirebaseMessage) => payload.data && payload.data.type === type),
        tap((payload: FirebaseMessage) => console.log('Message received. ', payload)),
        tap((payload: FirebaseMessage) => {
          if (payload.notification) {
            this.toastr.info(payload.notification.body, payload.notification.title);
          }
        })
      );
  }
}
